import { fetchWithAuth } from './http';

export type AudioUsageKind = 'podcast' | 'audiobook' | 'tts';

export interface AudioUsage {
  used: number;
  limit: number;
  remaining: number;
  subscriber: boolean;
  resetsAt?: string | null;
}

const USAGE_PATH = '/api/usage/audio-generation';

function normalize(raw: any): AudioUsage {
  return {
    used: Number(raw?.used ?? 0),
    limit: Number(raw?.limit ?? 0),
    remaining: Number(raw?.remaining ?? 0),
    subscriber: Boolean(raw?.subscriber),
    resetsAt: raw?.resetsAt ?? null,
  };
}

// Current weekly audio-generation allowance for the signed-in user. Usage is
// incremented server-side when audio is generated, so the client only reads it.
export async function getAudioUsage(): Promise<AudioUsage> {
  const res = await fetchWithAuth(USAGE_PATH);
  if (!res.ok) throw new Error(`Failed to load usage (${res.status})`);
  return normalize(await res.json());
}
